export enum ControlbarEditEntityType {
  THEME = 'theme',
  LINK = 'link',
}

export enum ControlbarEditParams {
  ENTITY_TYPE = 'controlbar-entity-type',
  ENTITY_ID = 'controlbar-entity-id',
}
